import { render, staticRenderFns } from "./GBBottomPaneProgressRateSetting.vue?vue&type=template&id=0e47aa40&"
import script from "./GBBottomPaneProgressRateSetting.vue?vue&type=script&lang=js&"
export * from "./GBBottomPaneProgressRateSetting.vue?vue&type=script&lang=js&"
import style0 from "./GBBottomPaneProgressRateSetting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/ganttboard/project/ganttboard-frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSlider } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex,VIcon,VLayout,VSlider,VTextField})
